<svg xmlns="http://www.w3.org/2000/svg" width="15" height="23" viewBox="0 0 15 23" fill="none">
    <rect width="15" height="23" fill="#F5F5F5"/>
    <g clip-path="url(#clip0_2_2)">
        <rect width="1440" height="1024" transform="translate(-1189 -380.041)" fill="white"/>
        <g clip-path="url(#clip1_2_2)">
            <rect x="-418.351" y="-135.53" width="646" height="153" rx="8" fill="white"/>
            <rect x="-418.351" y="-135.53" width="646" height="153" rx="8" fill="#CC9490" fill-opacity="0.16"/>
        </g>
        <rect width="640" height="944" transform="translate(-389 -300.041)" fill="white"/>
        <path d="M4 5.97946V3.54947C4.00264 3.1242 4.17343 2.71725 4.47507 2.41748C4.77672 2.1177 5.1847 1.94945 5.61 1.94946H8.4C8.8243 1.94946 9.2313 2.11803 9.5314 2.41809C9.8314 2.71815 10 3.12512 10 3.54947V5.94946H13.67L11.23 20.6295C11.1681 21.0056 10.9739 21.3473 10.6824 21.593C10.3908 21.8387 10.0212 21.9722 9.64 21.9695H4.36C3.98051 21.9698 3.61326 21.8352 3.32384 21.5897C3.03442 21.3443 2.84167 21.0039 2.78 20.6295L1 9.94946" stroke="#ADC2CA" stroke-width="2" stroke-miterlimit="10"/>
        <path d="M-1 5.97949H15" stroke="#ADC2CA" stroke-width="2" stroke-miterlimit="10" stroke-linecap="square"/>
    </g>
    <defs>
        <clipPath id="clip0_2_2">
            <rect width="1440" height="1024" fill="white" transform="translate(-1189 -380.041)"/>
        </clipPath>
        <clipPath id="clip1_2_2">
            <rect x="-1075.22" y="-135.53" width="1303" height="153" rx="8" fill="white"/>
        </clipPath>
    </defs>
</svg>